import { useState, useEffect } from "react";
import genie from "./genietm.png";
import { database } from "./firebase";
import { ref, get } from "firebase/database";
import { Helmet } from "react-helmet";
import {
  Text,
  Image,
  Center,
  Input,
  Button,
  VStack,
  FormControl,
  FormLabel,
  Box,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
} from "@chakra-ui/react";
import "./App.css";
import axios from "axios";

function App() {
  const [email, setEmail] = useState("");
  const [error, showError] = useState(false);
  const [success, showSuccess] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [aboutContent, setAboutContent] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");

  useEffect(() => {
    const aboutRef = ref(database, "about");
    get(aboutRef)
      .then((snapshot) => {
        if (snapshot.exists()) {
          setAboutContent(snapshot.val());
        } else {
          console.log("No about content available");
        }
      })
      .catch((error) => {
        console.error("Error fetching about content:", error);
      });
  }, []);

  const handleAbout = () => {
    setIsModalOpen(true);
  };

  const handleClose = () => {
    setIsModalOpen(false);
  };

  const addMember = async (email, firstName, lastName) => {
    try {
      const response = await axios.post(
        "https://hgapi.vercel.app/api/users/subscribe",
        {
          email: email,
          status: "subscribed",
          firstName: firstName,
          lastName: lastName,
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error adding member to list:", error);
      throw error;
    }
  };

  const handleSaveEmail = async () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (email === "" || !emailRegex.test(email)) {
      setErrorMsg("Please enter a valid e-mail address.");
      showError(true);
      return;
    } else if (firstName === "") {
      setErrorMsg(
        "Please enter your first name to avoid e-mail being marked as spam."
      );
      showError(true);
      return;
    } else if (lastName === "") {
      setErrorMsg(
        "Please enter your last name to avoid e-mail being marked as spam."
      );
      showError(true);
      return;
    }

    try {
      await addMember(email, firstName, lastName);
      showSuccess(true);
      showError(false);
    } catch (error) {
      console.error("Error saving email:", error);
      if (error.response && error.response.status === 500) {
        setErrorMsg(
          "This e-mail is already in use. Please try again with a different e-mail."
        );
      } else {
        setErrorMsg("An error occurred. Please try again later.");
      }
      showError(true);
      showSuccess(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>Hitting Genie</title>
        <link
          rel="icon"
          type="image/png"
          href="%PUBLIC_URL%/favicon.ico"
          sizes="16x16"
        />
      </Helmet>
      <Box pt={{ base: 3, md: 5 }} pl={{ base: 3, md: 5 }}>
        <Button
          size="lg"
          height={{ base: "40px", md: "48px" }}
          minW={{ base: "80px", md: "120px" }}
          fontSize={{ base: "sm", md: "md" }}
          fontFamily="Arial, sans-serif"
          fontWeight="600"
          bg="black"
          color="white"
          border="2px solid"
          borderColor="#FF4E00"
          borderRadius="md"
          onClick={handleAbout}
          _hover={{ bg: "gray.800", borderColor: "#FF4E00" }}
        >
          About
        </Button>
      </Box>
      <Center
        mt={{ base: 6, md: 10 }}
        flexDirection={{ base: "column", md: "row" }}
        px={4}
      >
        <Text
          marginLeft={{ base: 0, md: 24 }}
          px={{ base: 4, md: 10 }}
          fontSize={{ base: "xl", sm: "2xl", md: "xl", lg: "lg" }}
          fontWeight={"bold"}
          align={{ base: "center", md: "end" }}
          mb={{ base: 2, md: 0 }}
        >
          Now available for iOS!
        </Text>
        <a
          href="https://apps.apple.com/us/app/hitting-genie/id6478901041"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Image
            src="appStore.png"
            alt="Download on the App Store"
            maxW={{ base: "160px", sm: "200px", md: "none" }}
            w={{ base: "160px", sm: "200px", md: "auto" }}
          />
        </a>
      </Center>

      <Center minH="75vh" flexDirection="column" justifyContent="flex-start" pt={6} pb={10}>
        <Image
          src={genie}
          maxW={{ base: "280px", md: "80%", lg: "30%" }}
          mt={6}
          mb={8}
        />

        <Text px={6} fontSize={{ base: "xl", md: "xl" }} fontWeight="bold" textAlign="center" color="gray.800" mb={2}>
          Subscribe to receive arrival updates and free hitting advice.
        </Text>

        {success && (
          <Text color="green.600" fontSize={{ base: "lg", md: "md" }} fontWeight="600" textAlign="center" py={4} px={6}>
            Successfully subscribed! We will be in touch when updates appear.
          </Text>
        )}

        <VStack spacing={6} width={["100%", "90%", "400px"]} maxW="400px" px={4}>
          <FormControl isRequired>
            <FormLabel fontSize={{ base: "md", md: "md" }} fontWeight="bold" color="gray.700" mb={1.5}>
              First Name
            </FormLabel>
            <Input
              size="lg"
              height={{ base: "56px", md: "48px" }}
              bg="white"
              color="gray.800"
              fontFamily="Arial, sans-serif"
              fontSize={{ base: "16px", md: "md" }}
              placeholder="First Name"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              focusBorderColor="#FF4E00"
              border="2px solid"
              borderColor="#FF4E00"
              borderRadius="md"
              _placeholder={{ color: "gray.500" }}
              _hover={{ borderColor: "#FF4E00" }}
            />
          </FormControl>

          <FormControl id="lastName" isRequired>
            <FormLabel fontSize={{ base: "md", md: "md" }} fontWeight="600" color="gray.700" mb={1.5}>
              Last Name
            </FormLabel>
            <Input
              size="lg"
              height={{ base: "56px", md: "48px" }}
              bg="white"
              color="gray.800"
              fontFamily="Arial, sans-serif"
              fontSize={{ base: "16px", md: "md" }}
              placeholder="Last Name"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              focusBorderColor="#FF4E00"
              border="2px solid"
              borderColor="#FF4E00"
              borderRadius="md"
              _placeholder={{ color: "gray.500" }}
              _hover={{ borderColor: "#FF4E00" }}
            />
          </FormControl>

          <FormControl id="email" isRequired>
            <FormLabel fontSize={{ base: "md", md: "md" }} fontWeight="600" color="gray.700" mb={1.5}>
              Email Address
            </FormLabel>
            <Input
              size="lg"
              height={{ base: "56px", md: "48px" }}
              bg="white"
              color="gray.800"
              fontFamily="Arial, sans-serif"
              fontSize={{ base: "16px", md: "md" }}
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              focusBorderColor="#FF4E00"
              border="2px solid"
              borderColor="#FF4E00"
              borderRadius="md"
              _placeholder={{ color: "gray.500" }}
              _hover={{ borderColor: "#FF4E00" }}
            />
          </FormControl>

          {error && (
            <Text color="red.600" fontSize={{ base: "md", md: "sm" }} fontWeight="600" textAlign="center" w="100%">
              {errorMsg}
            </Text>
          )}

          <Button
            size="lg"
            height={{ base: "56px", md: "48px" }}
            fontSize={{ base: "lg", md: "md" }}
            fontFamily="Arial, sans-serif"
            fontWeight="600"
            onClick={handleSaveEmail}
            bg="black"
            color="white"
            border="2px solid"
            borderColor="#FF4E00"
            borderRadius="md"
            width="100%"
            mt={2}
            _hover={{ bg: "gray.800", borderColor: "#FF4E00" }}
          >
            Sign Up
          </Button>
        </VStack>

        <Modal isOpen={isModalOpen} onClose={handleClose} size="full" scrollBehavior="inside">
          <ModalOverlay bg="blackAlpha.800" />
          <ModalContent maxW={{ base: "100vw", md: "90vw", lg: "640px" }} maxH="90vh" my="auto" mx={{ base: 0, md: "auto" }}>
            <ModalHeader fontSize={{ base: "xl", md: "2xl" }} textAlign="center" pt={6} pb={2}>
              <Text as="span" borderBottom="2px solid" borderColor="#FF4E00" pb={1}>
                About
              </Text>
            </ModalHeader>
            <ModalCloseButton size="lg" top={4} right={4} fontSize={{ base: "20px", md: "16px" }} />
            <ModalBody pt={2} pb={8} px={{ base: 4, md: 8 }}>
              <Center mb={6}>
                <Image
                  src={genie}
                  maxW={{ base: "120px", md: "180px", lg: "200px" }}
                  alt="Hitting Genie"
                />
              </Center>
              <Box
                maxH="50vh"
                overflowY="auto"
                px={2}
                sx={{
                  "&::-webkit-scrollbar": { width: "8px" },
                  "&::-webkit-scrollbar-thumb": { bg: "gray.600", borderRadius: "4px" },
                }}
              >
                <Text
                  whiteSpace="pre-line"
                  fontSize={{ base: "md", md: "lg" }}
                  lineHeight="tall"
                  maxW="65ch"
                  mx="auto"
                  color="gray.800"
                >
                  {aboutContent}
                </Text>
              </Box>
            </ModalBody>
          </ModalContent>
        </Modal>
      </Center>
    </>
  );
}

export default App;
